// extracted by mini-css-extract-plugin
export var title = "copyHero-module--title--1gUdU";
export var section = "copyHero-module--section--1FlNx";
export var showTitle = "copyHero-module--showTitle--3OsMD";
export var shapeTransition = "copyHero-module--shapeTransition--lzHsZ";